<template lang="pug">
  #tlds
    router-view

    .view(v-if="showList")
      h2.mb-0.mt-1.mb-4 Available Domain Extensions
      .card
        slide-loader(:display="isLoading")
        .card-header
          .row
            .col-8
              button.btn.btn-success(@click="newTLD") New
            .col-4
        .card-body.p-0
          table.table
            thead
              tr
                th Extension
                th(style='text-align: center') Price
                th(style='text-align: center') Popular
                th
            tbody
              tr(v-for="tld in displayList", :key="tld._id")
                td
                  router-link(:to="{name: 'tlds.view', params: { id: tld._id }}") {{ '.'+tld.name }}
                  //- .small ID: {{ tld._id }}
                td(style='text-align: center')
                  span {{ priceFormat(tld.price) }}
                td(style='text-align: center')
                  span {{ tld.popular ? "Yes" : "No" }}
                td.text-right
                  button.btn.btn-danger.btn-sm(:disabled="isLoading", @click="removeTLD(tld)")
                    i.fa.fa-trash
                  router-link(:to="{name: 'tlds.view', params: { id: tld._id }}", class="btn btn-primary btn-sm ml-1", title="View TLD")
                    i.fa.fa-pencil

        .card-footer
          local-pagination(:source-list="list", v-model="displayList")
</template>

<script>
import LocalPagination from '../components/LocalPagination';

export default {
  name: 'TLDsPage',
  components: { LocalPagination },
  data: () => ({
    list: [],
    displayList: [],
    searchText: '',
    isLoading: false,
  }),
  computed: {
    showList() {
      return this.$route.name === 'tlds';
    },
  },
  watch: {
    showList(newValue) {
      if (newValue) this.refresh();
    },
  },
  mounted() {
    if (this.showList) this.refresh();
    this.$store.dispatch('SET_LOADER_STATE', false);
  },
  methods: {
    priceFormat(val) {
      return '$' + val / 100;
    },
    newTLD() {
      this.$router.push({ name: 'tlds.new' });
    },
    removeTLD(tld) {
      this.$bvModal
        .msgBoxConfirm(`Delete this TLD`, { centered: true })
        .then(res => {
          if (!res) return;

          this.isLoading = true;
          this.$http
            .delete(`v1/admin/tlds/${tld._id}`)
            .then(() => {
              this.$toast.success(
                'Complete',
                `.${tld.name} successfully removed.`,
              );
              this.refresh();
            })
            .catch(error => {
              this.$toast.error('TLD delete error', error.message);
              this.isLoading = false;
            });
        });
    },
    refresh() {
      this.isLoading = true;

      this.$http
        .get('v1/admin/tlds')
        .then(result => {
          this.list = result;
          this.isLoading = false;
        })
        .catch(error => {
          this.$toast.error('TLD list fetching error', error.message);
          this.isLoading = false;
        });
    },
  },
};
</script>
